import { render, staticRenderFns } from "./CoResultsPage.vue?vue&type=template&id=19790e7e"
import script from "./CoResultsPage.vue?vue&type=script&lang=js"
export * from "./CoResultsPage.vue?vue&type=script&lang=js"
import style0 from "./CoResultsPage.vue?vue&type=style&index=0&id=19790e7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports